import React, { useEffect, useState, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import ReactTable from "../../AppComponent/Table";
import {
  StetheAttendanceActions,
  ////--filters
  setRegionActions,
  setTheoptions,
  setThecountBasedRenders,
  setZoneActions,
  setGeoLoactionStateAction,
  StetheAttendanceApproveActions,
  setTheAttendance_RegularizationRange1,
  setTheAttendance_RegularizationRange2,
  setTheAttendance_RegularizationZone,
  setTheAttendance_RegularizationState,
  setTheAttendance_RegularizationRegion,
  setTheAttedanceRegurlarzationStatus,
  setTheAttendance_regularizationDesignation,
  setTablePositionPersist,
} from "../../../Redux/Slice";
import Select from "react-select";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Swal from "sweetalert2";
import AttendanceRequestApprove from "../../MainComponent/AttendanceRequestlist/AttendanceRequestApprove";
import { differenceInDays } from "date-fns";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import _ from "lodash";
// import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-06.svg";
import XmarksImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-06.svg";
import Checked from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-24.svg";
import ViewSymblos from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-23.svg";
import useDebouncedEffect from "use-debounced-effect";
import dayjs from "dayjs";
import { BulkActionBar, selectionColumn, useBulkSelection } from "./bulkApproval";

const AttendanceRequestlists = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist,
  );
  const dateRangeRef = useRef(null);

  const UserObjectData = useSelector((state) => state.users.UserData);
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [EditID, setEditId] = useState();
  const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.AttendanceActionspage?.page == undefined
      ? 1
      : TablePositionPersist.AttendanceActionspage.page,
  );
  const [search, setsearch] = useState(
    TablePositionPersist?.AttendanceActionspage?.search == undefined ||
      TablePositionPersist?.AttendanceActionspage?.search == ""
      ? ""
      : TablePositionPersist.AttendanceActionspage.search,
  );

  const [dtpagesize, setdtPagesize] = useState(20);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [EmployeePop, setEmployeePop] = useState(false);
  const [EmployeeIDs, setEmployeeIDs] = useState();
  const [UserIDState, setUserIdstate] = useState(false);
  const FileterState = {
    status:
      state.StateManagementOverallCall.Attendance_RegularizationStatusState
        ?.value,
  };
  const [selectDisplay, setDisplay] = useState([]);
  const [selectVal, SetSelectval] = useState(FileterState);
  const [FState, SetStates] = useState(false);
  ////--_FIlter--------------------------
  const [Filter, SetFilter] = useState(true);
  const [yearAndMonth, setYearMpnth] = useState();
  const date = new Date();
  console.log(date.getFullYear(), "date");
  const months =
    date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth();
  console.log(yearAndMonth, "yearAndMonth");
  const displaydate =
    date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  const YearList = date.getFullYear();
  //var yearAndMonth = `${date.getFullYear()}-${months}`;
  useEffect(() => {
    setYearMpnth(`${date.getFullYear()}-${months}`);
  }, []);

  const [Data, setdata] = useState({
    date: displaydate,
    month: months,
    year: YearList,
  });

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(
    state.StateManagementOverallCall.Attendance_RegularizationRange1,
  );
  var gt = convert(
    state.StateManagementOverallCall.Attendance_RegularizationRange2,
  );
  const today_day = dayjs().format("YYYY-MM-DD");

  const [range, setrange] = useState(
    state.StateManagementOverallCall.Attendance_RegularizationRange1 == ""
      ? [today_day, today_day]
      : [it, gt],
  );

  const handlechangedate = (value) => {
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const [readOnly, setreadonly] = useState(0);
  // bumped after a bulk approve/decline to reload the list
  const [reloadKey, setReloadKey] = useState(0);
  const selection = useBulkSelection(state.AttendanceCall.AttendanceListDatas);
  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setTheAttendance_RegularizationRange1(range[0]));
      dispatch(setTheAttendance_RegularizationRange2(range[1]));
    }
    if (
      state.StateManagementOverallCall.Attendance_RegularizationRange1 == ""
    ) {
      dispatch(setTheAttendance_RegularizationRange1(today_day));
      dispatch(setTheAttendance_RegularizationRange2(today_day));
    }
  }, [range]);

  const options = [
    { value: "", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "decline", label: "Decline" },
    { value: "approved", label: "Approved" },
  ];
  const [place, SetPlace] = useState("All");
  const [sel, setSelected] = useState();
  ///--filter----------------
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState(
    state.StateManagementOverallCall.Attendance_RegularizationRegion,
  );
  const [multiselect3, setMuliselect3] = useState(
    state.StateManagementOverallCall.Attendance_RegularizationZone,
  );
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [data, setDatas] = useState({
    zone: state.StateManagementOverallCall.Attendance_RegularizationZone?.value,
    state:
      state.StateManagementOverallCall.Attendance_RegularizationState?.value,
    region:
      state.StateManagementOverallCall.Attendance_RegularizationRegion?.value,
  });
  const [multiselect, setMuliselect] = useState([
    //  { value: "", label: "ALL" }
    state.StateManagementOverallCall.Attendance_RegularizationState,
    // state.ClientBranchIDs.StateName,
  ]);
  ///---filter for white collar--------
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "QPMS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);

  const [EMpROleSelected, setEmpRoleSele] = useState(
    state.StateManagementOverallCall
      .Attendance_RegularizationEmployeedesignation,
  );
  const [filterForWhite, setFilters] = useState({
    white_collar:
      state.StateManagementOverallCall
        .Attendance_RegularizationEmployeedesignation?.value == ""
        ? ""
        : state.StateManagementOverallCall
              .Attendance_RegularizationEmployeedesignation?.value == 1
          ? true
          : false,
  });

  const HandleEMprole = (e) => {
    setdtPageindex(1);
    dispatch(setTheAttendance_regularizationDesignation(e));

    if (e != null) {
      setEmpRoleSele(e);
      if (e.value == 1) {
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
      } else if (e.value == 2) {
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      } else if (e.value == "") {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
        dispatch(
          setTheAttendance_regularizationDesignation({
            value: "",
            label: "ALL",
          }),
        );
      }
    }
  };

  ///----filter-----
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);

  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };

  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch,
  );

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: currentPage,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);
  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: currentPage,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);
  useEffect(() => {
    const Datas = [];
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name });
      });
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];
    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });
      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    setdtPageindex(1);

    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      dispatch(setTheAttendance_RegularizationRegion(selectedVal));
      dispatch(
        setTheAttendance_RegularizationZone({ value: "", label: "ALL" }),
      );

      setDatas({
        ...data,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      dispatch(
        setTheAttendance_RegularizationRegion({ value: "", label: "ALL" }),
      );

      dispatch(
        setTheAttendance_RegularizationZone({ value: "", label: "ALL" }),
      );

      setDatas({
        ...data,
        region: "",
        zone: "",
      });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    setdtPageindex(1);

    if (selectedVal != null) {
      setMuliselect3(selectedVal);

      setDatas({
        ...data,
        zone: selectedVal.value,
      });

      dispatch(setTheAttendance_RegularizationZone(selectedVal));
    }
    if (selectedVal == null) {
      setDatas({
        ...data,
        zone: "",
      });
      setMuliselect3({ value: "search", label: "Search" });
      dispatch(
        setTheAttendance_RegularizationZone({ value: "", label: "ALL" }),
      );
    }
  };

  // console.log(state.StateManagementOverallCall.Attendance_RegularizationState , "Attendance_RegularizationRegion");

  const handleSelectChange = (selectedVal) => {
    setdtPageindex(1);
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      // console.log(selectedVal, "asfad");
      dispatch(setTheAttendance_RegularizationState(selectedVal));
      dispatch(
        setTheAttendance_RegularizationRegion({ value: "", label: "ALL" }),
      );
      dispatch(
        setTheAttendance_RegularizationZone({ value: "", label: "ALL" }),
      );

      setDatas({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
    }
    if (selectedVal == null) {
      setDatas({
        ...data,
        state: "",
        region: "",
        zone: "",
      });

      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(
        setTheAttendance_RegularizationState({ value: "", label: "ALL" }),
      );
      dispatch(
        setTheAttendance_RegularizationRegion({ value: "", label: "ALL" }),
      );
      dispatch(
        setTheAttendance_RegularizationZone({ value: "", label: "ALL" }),
      );
    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];
    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);
  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,
    });
  };

  ///---Region-----------------
  const handleInputRegion = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
    });
  };
  ///----Zone---Name
  const handleInputZone = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      zoneSearch: Val,
    });
  };

  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
        });
      }
    },
    500,
    [SearchDebounance],
  );

  //--------Place---Holder----dispatch======
  useEffect(() => {
    if (state.NumberCounts.namerednder == "") {
      dispatch(setTheoptions(options));
      SetPlace("All");
    }

    if (state.NumberCounts.namerednder == "Decline") {
      dispatch(setTheoptions(options[3]));
      SetPlace("Decline");
    }
    if (state.NumberCounts.namerednder == "Pending") {
      dispatch(setTheoptions(options[2]));
      SetPlace("Pending");
    }
  }, [state.NumberCounts.namerednder]);

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      const payload = {
        search: search,
        page_size: 20,
        page: dtpageindex,
        // month: Data.month,
        // year: Data.year,
        selectVal: selectVal,
        data: data,
        from_date: range[0],

        to_date: range[1],
        white_collar: filterForWhite.white_collar,
      };

      dispatch(StetheAttendanceActions(payload));
      dispatch(
        setTablePositionPersist({
          data: payload,
          pageName: "AttendanceActionspage",
        }),
      );
    }
    currentRef.current.scrollTop = sessionStorage.getItem(
      "AttendancerequestScrollpages",
    );
  }, [range, selectVal, data, dtpageindex, filterForWhite, search, reloadKey]);

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };
  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage);
  };

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);
  }
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    [],
  );
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const ClearState = (Counts) => {
    if (Counts == 2) {
      dispatch(
        setTheAttedanceRegurlarzationStatus({ value: "", label: "All" }),
      );
      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };
  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    setSelected(sel);
    SetStates(true);
    dispatch(setTheAttedanceRegurlarzationStatus(SelectedValues));
    if (values == "Pending") {
      ///Pending
      SetSelectval({
        ...selectVal,
        status: "pending",
      });
    } else if (values == "Decline") {
      //Decline
      SetSelectval({
        ...selectVal,
        status: "decline",
      });
    } else if (values == "Approved") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "approved",
      });
    } else if (values == "All") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };

  const columns = [
    selectionColumn(selection),
    //       {
    //   Header: "U-ID",
    //   accessor: "user_id.local_uid",
    //   Cell: ({ row }) => {
    //     const userId = row.original?.user_id?.local_uid;

    //     // Handle null, undefined, empty string, or whitespace
    //     const displayValue =
    //       userId == null || String(userId).trim() == "" ? "--" : userId;

    //     return <p className="PTAGs">{displayValue}</p>;
    //   },
    // },
    {
      Header: "Employee Code",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              className="UserName"
              style={{ cursor: "pointer" }}
              //    onClick={(e) => {
              //   handleEmployeeDetails(row.row.original);
              //}}
            >
              <div className="">
                <span>
                  {row.row.original.user_id?.user_uid != null &&
                  row.row.original.user_id?.user_uid != undefined &&
                  row.row.original.user_id?.user_uid != ""
                    ? row.row.original.user_id?.user_uid
                    : "--"}
                </span>
              </div>
            </div>
          </>
        );
      },
    },
    {
      Header: "Name",
      accessor: "",
      Cell: ({ row }) => {
        const { id, user_id } = row.original; // Destructure id and user_id from row data

        return (
          <>
            {user_id && user_id.first_name ? (
              <span>{user_id.first_name}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Email",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.email ? (
              <span>{row.row.original.user_id.email}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Role",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.user_role ? (
              <span>{row.row.original.user_id.user_role.role}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Apply Date",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.date != null &&
            row.row.original.date != undefined &&
            row.row.original.date != undefined ? (
              <span>{row.row.original.date}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Client",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.client_id != null &&
            row.row.original.client_id != undefined &&
            row.row.original.client_id.client_name != undefined ? (
              <span>{row.row.original.client_id.client_name}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Remarks",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.remarks ? (
              <span>{row.row.original.remarks}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Created Date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <p className="m-0">
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </p>
          </>
        );
      },
    },

    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => {
        const originalString = row.row.original.status;
        console.log(
          row.row.original.status,
          "usd9uwaswud",
          row.row.original.id,
        );
        const capitalizedString = capitalizeFirstLetter(originalString);
        return (
          <>
            {row.row.original.status != undefined ? (
              <>
                {row.row.original.status.toLowerCase() == "pending" ? (
                  <div className="StatusList">
                    <img src={Pendingimg} />
                    <span>{capitalizedString}</span>
                  </div>
                ) : (
                  <>
                    {row.row.original.status.toLowerCase() == "decline" ? (
                      <div className="StatusList">
                        <div className="DeclineStatus">
                          <span>x</span>
                        </div>
                        <span>{capitalizedString}</span>
                      </div>
                    ) : (
                      <>
                        {row.row.original.status.toLowerCase() == "approved" ? (
                          <div className="StatusList">
                            <img src={correctIcons} />
                            <span>{capitalizedString}</span>
                          </div>
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actionsAttendance actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                component="span"
                onClick={(e) => {
                  // if (!row.row.original.status.toLowerCase() == "approved") {
                  setEmployeePop(true);
                  setEmployeeIDs(row.row.original.id);
                  setreadonly(0);

                  // }
                }}
                style={{
                  borderRadius: "50%",
                  width: "35px",
                  height: "35px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span className="OuterActionSpan_ OuterAction_Attendance_request">
                  <span className="EditImages">
                    <img src={ViewSymblos} />
                  </span>
                </span>
              </button>

              <>
                <button
                  className=" btn Status"
                  component="span"
                  disabled={
                    row.row.original.status.toLowerCase() != "pending"
                      ? true
                      : false
                  }
                  onClick={(e) => {
                    if (row.row.original.status.toLowerCase() == "pending") {
                      // setEmployeePop(true);
                      setEmployeeIDs(row.row.original.id);
                      setreadonly(0);

                      Swal.fire({
                        title: `Do you want to Decline ?`,
                        // text: "You won't be able to revert this",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#234492",
                        cancelButtonColor: "#6c757d",
                        confirmButtonText: "Yes",
                        allowOutsideClick: false, // Prevent closing on outside click
                      }).then((result) => {
                        if (result.isConfirmed) {
                          Swal.fire({
                            title: "Do you want to Decline?",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#234492",
                            cancelButtonColor: "#6c757d",
                            confirmButtonText: "Yes, Decline it!",
                            input: "text",
                            inputPlaceholder: "Reason for decline...",
                            allowOutsideClick: false,

                            inputValidator: (value) => {
                              if (!value) {
                                return "You need to provide a reason for declining";
                              }
                            },
                          }).then((result) => {
                            if (result.isConfirmed) {
                              const reason = result.value;
                              const payload = {
                                status: "decline",
                                description: reason,
                                EditId: row.row.original.id,
                                currentPage: currentPage,
                                selectVal: selectVal,
                                data: data,
                                from_date: range[0],
                                to_date: range[1],
                                white_collar: filterForWhite.white_collar,
                                search: search,
                              };
                              dispatch(StetheAttendanceApproveActions(payload));
                            } else if (
                              result.dismiss === Swal.DismissReason.cancel
                            ) {
                              Swal.fire({
                                // text: " Employee verification as been cancel",
                                icon: "error",
                              });
                              Swal.close();
                            }
                          });
                        } else if (
                          result.dismiss === Swal.DismissReason.cancel
                        ) {
                          Swal.close();
                        }
                      });
                    }
                  }}
                  style={{
                    borderRadius: "50%",
                    width: "35px",
                    height: "35px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <span className="OuterActionSpan_ OuterAction_Attendance_request">
                    <span className="EditImages">
                      <img src={XmarksImage} />
                    </span>
                  </span>
                </button>

                <button
                  className=" btn Status"
                  component="span"
                  disabled={
                    row.row.original.status.toLowerCase() != "pending"
                      ? true
                      : false
                  }
                  onClick={(e) => {
                    if (
                      row.row.original.status != undefined &&
                      row.row.original.status != null &&
                      row.row.original.status.toLowerCase() == "pending"
                    ) {
                      setEmployeeIDs(row.row.original.id);
                      setreadonly(0);

                      Swal.fire({
                        title: `Do you want to Approve ?`,
                        // text: "You won't be able to revert this",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#234492",
                        cancelButtonColor: "#6c757d",
                        confirmButtonText: "Yes",
                      }).then((result) => {
                        console.log(result, "result");
                        if (result.isConfirmed) {
                          const payload = {
                            status: "approved",
                            description: "",
                            EditId: row.row.original.id,
                            currentPage: currentPage,
                            selectVal: selectVal,
                            data: data,
                            from_date: range[0],
                            to_date: range[1],
                            white_collar: filterForWhite.white_collar,
                            search: search,
                          };
                          console.log(payload, "payload");
                          dispatch(StetheAttendanceApproveActions(payload));
                        } else if (
                          result.dismiss === Swal.DismissReason.cancel
                        ) {
                          Swal.close();
                        }
                      });
                    }
                  }}
                  style={{
                    borderRadius: "50%",
                    width: "35px",
                    height: "35px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <span className="OuterActionSpan_">
                    <span className="EditImages">
                      <img src={Checked} />
                    </span>
                  </span>
                </button>
              </>
            </div>
          </>
        );
      },
    },
  ];

  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];
  const openMe = () => {
    const rsAnimFade = document.querySelector(".rs-anim-fade");
    if (rsAnimFade) {
      rsAnimFade.style.setProperty("left", "631.344px", "important");
      rsAnimFade.style.setProperty("top", "182.109px", "important");
    }
  };

  const CloseDateRange = () => {
    const rsAnimFade = document.querySelector(".rs-anim-fade");
    if (rsAnimFade) {
      rsAnimFade.style.setProperty("display", "none", "important");
    }
  };

  const currentRef = useRef();
  const scrollPosition = (e) => {
    const val = currentRef.current.scrollTop;
    sessionStorage.setItem("AttendancerequestScrollpages", val);
  };

  const getZoomFactor = () => {
    const zoom = document.body.style.zoom;
    return zoom ? parseFloat(zoom) / 100 : 1;
  };

  const alignDateRangePicker = (pickerNode) => {
    const picker = pickerNode?.root || pickerNode?.container || pickerNode;

    const popup = document.querySelector(
      ".rs-picker-popup.rs-picker-popup-daterange",
    );

    if (!picker || !popup) return;

    const zoom = getZoomFactor();
    const rect = picker.getBoundingClientRect();

    const popupWidth = popup.offsetWidth;
    const popupHeight = popup.offsetHeight;

    const viewportWidth = window.innerWidth / zoom;
    const viewportHeight = window.innerHeight / zoom;

    const scrollX = window.scrollX / zoom;
    const scrollY = window.scrollY / zoom;

    let left = rect.right / zoom - popupWidth + scrollX;
    let top = rect.bottom / zoom + 8 + scrollY;

    if (left < 8) left = 8;
    if (left + popupWidth > viewportWidth - 8) {
      left = viewportWidth - popupWidth - 8;
    }

    if (top + popupHeight > viewportHeight + scrollY - 8) {
      top = rect.top / zoom - popupHeight - 8 + scrollY;
    }

    popup.style.position = "absolute";
    popup.style.left = `${left}px`;
    popup.style.top = `${top}px`;
  };

  return (
    <>
      <div
        onScroll={scrollPosition}
        ref={currentRef}
        className={stateDisplay ? "outterContent" : "inner-Content"}
      >
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Attendance Regularization </h3>
          </div>
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "90",

            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              State
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              placeholder={"Search"}
              value={multiselect}
            />
          </div>
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Region
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={
                multiselect1
                  ? Array.isArray(multiselect1)
                    ? multiselect1.some(
                        (item) => item.label === "ALL" || item.label === "All",
                      )
                      ? false
                      : true
                    : multiselect1.label === "ALL" ||
                        multiselect1.label === "All"
                      ? false
                      : true
                  : true
              }
              value={multiselect1}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              onInputChange={handleInputRegion}
            />
          </div>
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Zone
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              options={nameList4}
              isClearable={
                multiselect3
                  ? Array.isArray(multiselect3)
                    ? multiselect3.some(
                        (item) => item.label === "ALL" || item.label === "All",
                      )
                      ? false
                      : true
                    : multiselect3.label === "ALL" ||
                        multiselect3.label === "All"
                      ? false
                      : true
                  : true
              }
              value={multiselect3}
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
              // placeholder={
              //   data.state == ""
              //     ? "without selected state you can't select Zone"
              //     : data.region == ""
              //     ? "without selected Region you can't select Zone"
              //     : "Search"
              // }
            />
          </div>

          <div className="col-sm-2">
            <label
              for="validationCustom01"
              class="form-label"
              style={{ marginBottom: "11px" }}
            >
              Select Date
              <span style={{ color: "red" }}>*</span>
            </label>

            <div className="datepicker_dash" style={{ marginTop: "-5px" }}>
              <DateRangePicker
                defaultValue={
                  state.StateManagementOverallCall
                    .Attendance_RegularizationRange1 == ""
                    ? [new Date(range[0]), new Date(range[1])]
                    : [
                        new Date(
                          state.StateManagementOverallCall
                            .Attendance_RegularizationRange1,
                        ),
                        new Date(
                          state.StateManagementOverallCall
                            .Attendance_RegularizationRange2,
                        ),
                      ]
                }
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                onOpen={() => {
                  setTimeout(() => {
                    alignDateRangePicker(dateRangeRef.current);
                  }, 80);
                }}
                ref={dateRangeRef}
                style={{
                  width: "100%",
                  padding: "0px 5px",
                }}
                placeholder="From - To"
                // style={{ width: 270, padding: 10 }}
                onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  if (e != null && e.length === 2) {
                    const [startDate, endDate] = e;
                    const diffDays = differenceInDays(endDate, startDate);

                    setrange([]);
                    e.forEach((newValue) => {
                      const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                      const localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      handlechangedate(localISOTime);
                    });
                  }
                }}
              />
            </div>
          </div>
        </div>

        <div
          style={{
            padding: " 0px 40px",
            marginTop: "-13px",
            marginBottom: "20px",
          }}
        >
          <BulkActionBar
            selection={selection}
            label="attendance request"
            onDone={() => setReloadKey((k) => k + 1)}
          />
          <ReactTable
            data={state.AttendanceCall.AttendanceListDatas}
            columns={columns}
            totalItems={state.AttendanceCall.Total_count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.AttendanceCall.Total_count}
            values={
              state.StateManagementOverallCall
                .Attendance_RegularizationStatusState
            }
            options={options}
            Filter={Filter}
            count={count}
            ClearState={ClearState}
            placeHold={place}
            ApproveRequestFilter={true}
            ///--- emoloyee role based filters -
            EmployeeRoleTrue={true}
            EmployeeRoleOption={EmpRoles}
            EMpROleSelected={
              state.StateManagementOverallCall
                .Attendance_RegularizationEmployeedesignation
            }
            HandleEMprole={HandleEMprole}
            searchVal={
              TablePositionPersist?.AttendanceActionspage?.search == "" ||
              TablePositionPersist?.AttendanceActionspage?.search == undefined
                ? ""
                : TablePositionPersist.AttendanceActionspage.search
            }
            search_key={true}
          />
        </div>
      </div>
      {EmployeePop && EmployeeIDs != undefined && selectVal ? (
        <AttendanceRequestApprove
          show={EmployeeIDs}
          setShow={setEmployeePop}
          currentPage={dtpageindex}
          EditId={EmployeeIDs}
          selectVal={selectVal}
          // month={Data.month}
          // year={Data.year}

          makereadOnly={readOnly}
          search={search}
          from_dates={range[0]}
          to_dates={range[1]}
          data={data}
          white_collar={filterForWhite.white_collar}
        />
      ) : null}
    </>
  );
};

export default AttendanceRequestlists;
